// External libraries
import { css } from '@emotion/core';

export const errorStyleOverrides = css`
  padding-left: 37px;
`;

export const textStyles = css`
  line-height: 1.6;
  text-align: left;
`;
